import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWhoPays = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.38867 7.68555C8.16236 7.68564 8.92022 7.84124 9.62012 8.13477C9.87459 8.24153 9.99418 8.53453 9.8877 8.78906C9.78089 9.04367 9.48802 9.16339 9.2334 9.05664C8.6548 8.814 8.02823 8.68564 7.38867 8.68555C6.12346 8.68555 4.90936 9.18846 4.01465 10.083C3.12 10.9777 2.61729 12.1918 2.61719 13.457C2.61695 13.7329 2.39307 13.9569 2.11719 13.957C1.84119 13.957 1.61743 13.733 1.61719 13.457C1.61729 11.9266 2.22543 10.4582 3.30762 9.37598C4.38987 8.2939 5.85825 7.68555 7.38867 7.68555ZM7.3877 0.792969C8.27297 0.793032 9.12304 1.14452 9.74902 1.77051C10.3748 2.39643 10.7264 3.24575 10.7266 4.13086C10.7266 5.01615 10.375 5.86616 9.74902 6.49219C9.12304 7.11817 8.27297 7.46966 7.3877 7.46973C6.50257 7.46963 5.65328 7.11801 5.02734 6.49219C4.4013 5.86614 4.0498 5.01622 4.0498 4.13086C4.04992 3.24565 4.4014 2.39645 5.02734 1.77051C5.65329 1.14464 6.50254 0.793064 7.3877 0.792969ZM7.3877 1.79297C6.76775 1.79306 6.17278 2.03921 5.73438 2.47754C5.29597 2.91595 5.04992 3.51087 5.0498 4.13086C5.0498 4.75083 5.29609 5.34571 5.73438 5.78418C6.17279 6.22255 6.76772 6.46963 7.3877 6.46973C8.00775 6.46966 8.60257 6.22263 9.04102 5.78418C9.47943 5.34569 9.72656 4.75093 9.72656 4.13086C9.72645 3.51091 9.47937 2.91594 9.04102 2.47754C8.6026 2.03931 8.00758 1.79303 7.3877 1.79297Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.3769 13.0654C11.5343 13.2724 11.7393 13.4384 11.9746 13.5492C12.2099 13.66 12.4684 13.7123 12.7283 13.7018C13.5567 13.7018 14.2288 13.1977 14.2288 12.5766C14.2288 11.9555 13.5567 11.4514 12.7283 11.4514C11.8998 11.4514 11.2285 10.9474 11.2285 10.3255C11.2285 9.70363 11.8998 9.20032 12.7283 9.20032C12.9881 9.18997 13.2466 9.24241 13.4818 9.3532C13.7171 9.46398 13.9222 9.62985 14.0797 9.83673",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7275 13.7059V14.4558",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.7275 8.45581V9.20497",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgWhoPays;
